module.exports = __webpack_public_path__ + "media/images/metronic/social/wordpress-04f8415b9f5a7179f55d630515d1080e.png";